/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Class that define the BASE request payload for a collection operation without products
 */
export type PayOnlyOperationReqBaseDTO = {
    /**
     * Amount to pay
     */
    amount: number;
    /**
     * Currency of the operation
     */
    currency: PayOnlyOperationReqBaseDTO.currency;
    /**
     * Description given by the merchant about the payment collection
     */
    description?: string;
};

export namespace PayOnlyOperationReqBaseDTO {

    /**
     * Currency of the operation
     */
    export enum currency {
        GHS = 'GHS',
        NGN = 'NGN',
    }


}
